/**
 * Analytics léger — Plausible et/ou GA4 via env.
 * REACT_APP_PLAUSIBLE_DOMAIN=reflexologue-savoie.com
 * REACT_APP_GA4_ID=G-XXXXXXXX
 */

const PLAUSIBLE = process.env.REACT_APP_PLAUSIBLE_DOMAIN || "";
const GA4 = process.env.REACT_APP_GA4_ID || "";

export function analyticsEnabled() {
    return Boolean(PLAUSIBLE || GA4);
}

export function trackEvent(name, props = {}) {
    try {
        if (PLAUSIBLE && typeof window !== "undefined" && window.plausible) {
            window.plausible(name, { props });
        }
        if (GA4 && typeof window !== "undefined" && window.gtag) {
            window.gtag("event", name, props);
        }
    } catch {
        /* ignore */
    }
}

export function trackTel() {
    trackEvent("Lead Tel", { method: "phone" });
}

export function trackFormSuccess(motif = "") {
    trackEvent("Lead Form", { method: "form", motif: String(motif).slice(0, 80) });
}

export function trackWhatsApp(source = "whatsapp") {
    trackEvent("Lead WhatsApp", { method: "whatsapp", source });
}

export function trackContactCta(source = "cta") {
    trackEvent("Click Contact", { source });
}
